/**************************************************************************************************/
/** @import Helpers/Components                                                                   **/
/**************************************************************************************************/
import { BaseInput } from '@/Helpers/Components/DataForm/BaseInput'

/**************************************************************************************************/
/** @export Class @name InputText                                                                **/
/**************************************************************************************************/
export class InputText extends BaseInput
{
	/*************************************************/
	/** @Constructor                                **/
	/*************************************************/
	constructor(key: string, label: string)
	{
		super()
		this.Key   = key
		this.Label = label
		this.setParamsState(this.resolveInputState)
		this.setParamsType('text')
	}

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	public resolveInputState(self: any) : boolean | null
	{
		if (!self.value) return null
		const aux = self.value.trim()
		if (aux === '') return null
		if (aux.length < 3 || aux.length > 120) return false
		return true
	}
}